import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import "../../components/CommunicationTemplete/CommunicationTemplate.css";
import CommunicationErrorsTable from '../../components/CommunicationError/CommunicationErrorsTable';

const defaultTheme = createTheme();

const CommunicationErrorSLog = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Communication Errors</h1>
          <p>Review failed WhatsApp &amp; email alerts and the reasons they didn't send.</p>
        </div>
      </div>

      <CommunicationErrorsTable />
    </ThemeProvider>
  );
};

export default CommunicationErrorSLog;